import MenuIcon from '@mui/icons-material/Menu';

export default MenuIcon;
